import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/lincard_left_tips_img.svg'
import _imports_1 from '../assets/images/lincard_rigtht_text.svg'
import _imports_2 from '../assets/images/right_line_tips_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-0843faa5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_content_bg" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"linkcard_tips_bg\" data-v-0843faa5><div class=\"left_text_bg\" data-v-0843faa5><img class=\"left_tips_img\" src=\"" + _imports_0 + "\" alt=\"\" data-v-0843faa5><span data-v-0843faa5>轻松配置你的专属 AI 智能体</span></div><div class=\"right_tips_view\" data-v-0843faa5><div class=\"right_cover_card\" data-v-0843faa5></div><img class=\"lincard_rigtht_text_img\" src=\"" + _imports_1 + "\" alt=\"\" data-v-0843faa5><img class=\"right_line_tips_img\" src=\"" + _imports_2 + "\" alt=\"\" data-v-0843faa5></div></div>", 1)
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = { class: "card-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab active" }, "他们在用")
], -1))
const _hoisted_6 = { class: "right-wrapper" }
const _hoisted_7 = ["infinite-scroll-disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkardInfoItem = _resolveComponent("LinkardInfoItem")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("ul", {
            class: "card-list",
            "infinite-scroll-disabled": _ctx.noMoreCollectListData
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectList, (linkInfo, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_LinkardInfoItem, { linkardInfo: linkInfo }, null, 8, ["linkardInfo"])
              ]))
            }), 128))
          ], 8, _hoisted_7)), [
            [_directive_infinite_scroll, _ctx.getCollectListRequest]
          ])
        ])
      ])
    ])
  ]))
}